module.exports = [
  { code: "1", name: "1 > 10" },
  { code: "2", name: "10 > 50" },
  { code: "3", name: "50 > 100" },
  { code: "4", name: "100 > 500" },
  { code: "5", name: "500 > 1000" },
  { code: "6", name: "1000 > above" },
];
